module.exports = __webpack_public_path__ + "img/google-play-store.600507c1.svg";